import type { AppearanceMode } from '../JobCard';

import { GAP_HEIGHT, getMaxHeight } from './AttributeComponent';
import { Box } from '../../../../mads';
import { useI18n } from '../../../../shared/I18n';


import { Children, cloneElement, isValidElement, useCallback, useState } from 'react';
import { Platform, StyleSheet } from 'react-native';

export function AttributesContainer({
    children,
    appearanceMode,
}: {
    children: React.ReactNode;
    appearanceMode?: AppearanceMode;
}) {
    const i18n = useI18n();
    const [tagHeight, setTagHeight] = useState(0);
    const handleTagHeightChanged = useCallback((height: number) => {
        setTagHeight(prev => Math.max(prev, height));
    }, []);

    const childrenWithProps = Children.map(children, (child) => {
        if (isValidElement(child)) {
            return cloneElement(child as React.ReactElement<{ onTagHeightChanged?: (height: number) => void }>, { onTagHeightChanged: handleTagHeightChanged });
        }
        return child;
    });

    return (
        <Box>
            <Box
                accessibilityLabel={i18n.gettext('Group of job attributes')}
                accessibilityRole={Platform.OS === 'android' ? 'list' : undefined}
                sx={{
                    ...styles.attrsContainer,
                    ...{ maxHeight: tagHeight > 0 ? getMaxHeight(tagHeight) : undefined },
                    ...(appearanceMode === 'default' ? styles.attrsContainerDefault : {}),
                }}
            >
                {childrenWithProps}
            </Box>
        </Box>
    );
}
const styles = StyleSheet.create({
    attrsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 6,
        gap: GAP_HEIGHT,
        overflow: 'hidden',
    },
    attrsContainerDefault: {
        marginBottom: 8,
    },
});
